import { combineReducers } from "redux";

import users from "./users";
import blogs from "./blogs";
import flash from "./flash";

export default combineReducers({ blogs, users, flash });